/**
 * Contextual feedback under the staff.
 *
 * It appears for allowed-notes dead ends and for the post-grade summary.
 * Written-note verdicts begin when the student asks for a grade.
 */

import type { JSX } from 'react';
import { useSession } from '../state/store';

export function StatusStrip(): JSX.Element | null {
  const legality = useSession((s) => s.legality);
  const hoverMeasure = useSession((s) => s.hoverMeasure);
  const report = useSession((s) => s.report);
  const assists = useSession((s) => s.settings.assists);

  const hoveredDeadEnd = hoverMeasure != null ? legality.deadEnds[hoverMeasure] : undefined;

  if (hoveredDeadEnd && hoveredDeadEnd.length && !report) {
    return (
      <div className="status status--alarm" role="status">
        <b>Measure {hoverMeasure! + 1} has no legal note left.</b>{' '}
        {hoveredDeadEnd.slice(0, 3).join('; ')}
        {hoveredDeadEnd.length > 3 ? ' …' : ''}
      </div>
    );
  }

  if (assists.allowed && legality.positionDead && !report) {
    return (
      <div className="status status--alarm" role="status">
        No legal completion exists from here. Undo, or lift a note from an earlier measure.
      </div>
    );
  }

  if (report) {
    const errors = report.analysis.findings.filter((f) => f.severity === 'error').length;
    return (
      <div className="status" role="status">
        {errors === 0
          ? 'Graded — no rule violations.'
          : `Graded — ${errors} violation${errors === 1 ? '' : 's'}. Editing a note retracts the report.`}
      </div>
    );
  }

  return null;
}
